import React, { useState, useEffect } from 'react';
import GridContainer from 'components/Grid/GridContainer';
import Modal from 'components/Tvendo/Common/ModalBase';
import GridItem from 'components/Grid/GridItem';
import { TextField } from '@material-ui/core';

function EditModal(props) {
  const { setOrders } = props;
  const order = props.model;

  const [comment, setComment] = useState('');

  function onSave() {
    setOrders((orders) => {
      let index = orders.findIndex((item) => item.id === order.id);
      if (index === false) return orders;
      orders[index].comments = comment;
      return orders;
    });
  }

  useEffect(() => {
    setComment(order.comments || '');
  }, [order]);

  return (
    <Modal
      title={`Pedido ${order.id}`}
      model={props.model}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={onSave}
      entity="sale/order"
    >
      <GridContainer>
        <GridItem xs={6}>
          <h6>Cliente</h6>
          <h5>{order.CardName}</h5>
        </GridItem>
        <GridItem xs={6}>
          <h6>Vendedor</h6>
          <h5>{order.SlpName}</h5>
        </GridItem>
        <GridItem xs={6}>
          <h6>Total</h6>
          <h5>{order.total_order}</h5>
        </GridItem>
        <GridItem xs={6}>
          <h6>Fecha documento</h6>
          <h5>{order.date_order}</h5>
        </GridItem>
      </GridContainer>
      <TextField
        label="Hoja reparto (Comentario)"
        fullWidth
        type="text"
        name="comments"
        margin="normal"
        value={comment || ''}
        onInput={(e) => {
          setComment(e.target.value);
        }}
        required
      />
    </Modal>
  );
}

export default EditModal;
